import React from 'react';
import IconClose from '../icons/IconClose';
import { useTranslation } from 'react-i18next';

const Modal = ({
    title,
    children,
    onClose,
    actions = [],
}: {
    title: string;
    children: React.ReactNode;
    onClose: () => void;
    actions?: { label: string; onClick: () => void; variant?: string }[];
}) => {
    const { t } = useTranslation();
    return (
        <div className="fireknife-modal-overlay">
            <div className="fireknife-modal">
                <div className="fireknife-modal__header">
                    <h2 className="fireknife-modal__title">{title}</h2>
                    <button
                        className="fireknife-modal__close-btn fireknife-btn"
                        onClick={onClose}
                        aria-label={t('common.close')}
                    >
                        <IconClose className="fireknife-modal__close-btn-icon" />
                    </button>
                </div>

                <div className="fireknife-modal__content">{children}</div>

                <div className="fireknife-modal__footer">
                    {actions.map((action, index) => (
                        <button
                            key={index}
                            className={`fireknife-modal__footer-btn fireknife-btn ${action.variant || ''}`}
                            onClick={action.onClick}
                            type="button"
                        >
                            {action.label}
                        </button>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default Modal;
